import GATEWAY_CONSTANTS from "../constants/gatewayConstants";
import base from "../utils/stores/base";

let gatewayStore = {
    getInitialState() {
        return {
            data: this.app.data.gateway || {},
            formError: null,
            submitting: false
        };
    },
    handlers: {
        setFormError: [
            GATEWAY_CONSTANTS.STRIPE_CREATE_TOKEN_FAILED,
            GATEWAY_CONSTANTS.STRIPE_CREATE_TRANSACTION_FAILED,
            GATEWAY_CONSTANTS.STRIPE_SET_ERROR
        ],
        setSubmitting: [
            GATEWAY_CONSTANTS.STRIPE_CREATE_TOKEN_STARTING,
            GATEWAY_CONSTANTS.STRIPE_CREATE_TRANSACTION_DONE
        ]
    },
    setFormError(error) {
        let errorState = !error ? null : {
            [error.data.param]: error.data.message
        };

        this.setState({
            formError: errorState,
            submitting: false
        });
    },
    fetch() {
        return this.state.data;
    },
    error() {
        return this.state.formError;
    },
    setSubmitting(state) {
        this.setState({
            submitting: typeof state === "boolean" ? state : state ? !this.state.submitting : false
        });
    },
    submitting() {
        return this.state.submitting;
    }
};

export default base(gatewayStore, GATEWAY_CONSTANTS);



/** WEBPACK FOOTER **
 ** ./app/stores/gatewayStore.js
 **/